// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d6um","controls":"styles_controls__3V9VS","charLimit":"styles_charLimit__3DQ6x","input":"styles_input__UO67q","send":"styles_send__175Hh"};